// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3416b1ab","239":"8658698b","455":"bea841d7"}[chunkId] + ".chunk.js";
};